'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('../');

var _models = require('../../models');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// Components


// Models


var GeckoCardTable = function (_Component) {
    _inherits(GeckoCardTable, _Component);

    function GeckoCardTable() {
        _classCallCheck(this, GeckoCardTable);

        return _possibleConstructorReturn(this, (GeckoCardTable.__proto__ || Object.getPrototypeOf(GeckoCardTable)).apply(this, arguments));
    }

    _createClass(GeckoCardTable, [{
        key: 'renderHeader',
        value: function renderHeader() {
            return _react2.default.createElement(_.GeckoCardHeader, {
                name: this.props.name,
                btns: this.props.headerBtns,
                searchHandler: this.props.searchHandler });
        }
    }, {
        key: 'renderTable',
        value: function renderTable() {
            return _react2.default.createElement(
                _.GeckoCardBody,
                null,
                _react2.default.createElement(_.GeckoTable, {
                    rows: this.props.rows,
                    cols: this.props.cols,
                    rowHandler: this.props.rowHandler.bind(this),
                    pagination: this.props.pagination,
                    hideTableHeader: this.props.hideTableHeader })
            );
        }
    }, {
        key: 'renderAlert',
        value: function renderAlert() {
            return _react2.default.createElement(
                _.GeckoCardBody,
                { padded: true },
                _react2.default.createElement(
                    _.GeckoAlert,
                    { type: 'warning' },
                    'There are no results to show.'
                )
            );
        }
    }, {
        key: 'renderBody',
        value: function renderBody() {
            if (this.props.rows && this.props.rows.length) {
                return this.renderTable();
            }
            return this.renderAlert();
        }
    }, {
        key: 'renderFooter',
        value: function renderFooter() {
            return _react2.default.createElement(
                _.GeckoCardFooter,
                null,
                _react2.default.createElement(_.GeckoPagination, { pagination: this.props.pagination })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _.GeckoCardWrapper,
                null,
                this.renderHeader(),
                this.renderBody(),
                this.renderFooter()
            );
        }
    }]);

    return GeckoCardTable;
}(_react.Component);

GeckoCardTable.defaultProps = {
    headerBtns: [],
    cols: [],
    rows: [],
    hideTableHeader: false,
    rowHandler: function rowHandler() {},
    pagination: {}
};

GeckoCardTable.propTypes = {
    headerBtns: _models.GeckoBtnsModel,
    cols: _models.GeckoTableCellsModel.isRequired,
    rows: _propTypes2.default.array.isRequired,
    hideTableHeader: _propTypes2.default.bool,
    rowHandler: _propTypes2.default.func,
    pagination: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape(_models.GeckoPaginationModel)]),
    searchHandler: _propTypes2.default.func
};

exports.default = GeckoCardTable;